import script from "./PropertyOwnerDashboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./PropertyOwnerDashboard.vue?vue&type=script&lang=ts&setup=true"

import "./PropertyOwnerDashboard.vue?vue&type=style&index=0&id=76593a06&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76593a06"]])

export default __exports__